module.exports = __webpack_public_path__ + "static/media/benefits1.5abe8aa5.webp";